export const Colors = {
    primary: "#FBBA1E",
    secondary: "#1FC6C7",
    white: "#ffffff",
    smokeWhite: "#FBFBFB",
    black: "#1c1c1c",
    blueShade: "#277d98",
    grey: "#E6E8EE",
    greyText: "#9b9b9b",
    danger: "#D32F2F",
    smokeGreen: "#fbfbfb",
    danger: "#FF0000",
    silver:"#f3f3f3",
    blue:"#00359b",
    yellow: "#fdc609",
    green:"#4d901b"
  };
  